const keywordSections = document.querySelectorAll(".keyword-content");

// Add click event to all buttons
document.querySelectorAll(".keyword-button").forEach((button) => {
  button.addEventListener("click", function () {
    document.getElementById(button.dataset.keyword).style.display = "block";
    document.getElementById(button.dataset.modal).style.display = "block";
  });
});

// Close the modal when the user clicks on <span> (x)
document.querySelectorAll(".close-button").forEach((button) => {
  button.addEventListener("click", function (event) {
    closeModal(event.currentTarget.dataset.modal);
  });
});

document.querySelectorAll(".keyword-modal").forEach((button) => {
  button.addEventListener("click", function (event) {
    if (event.currentTarget == event.target) {
      closeModal(event.currentTarget.dataset.modal);
    }
  });
});

function closeModal(id) {
  document.getElementById(id).style.display = "none";
  keywordSections.forEach((section) => {
    section.style.display = "none";
  });
}
